import React, { Component } from 'react';
import { BrowserRouter as Router, Redirect, Route, Link, Switch } from 'react-router-dom';
import { auth } from "./config/fire";
//Pages
import Home from "./pages/Home";
import About from "./pages/About";
import NoPage from "./pages/404";
import Auth from "./pages/Auth";
import UserProfile from "./pages/UserProfile";
import Room from './pages/Room';
// import CreateRoom from './pages/CreateRoom';
import Redirec from './pages/Redirec';
// import CallEnded from './pages/CallEnded';
// import Scheduled from './pages/Scheduled';
import Dashboard from './pages/Dashboard';
import MyEvents from './pages/MyEvents';
import Loader from './components/Loader';
import CallEnded from './pages/CallEnded';
import Waiting from './pages/Waiting';
import Roomi from './components/RoomMain';

// import CreateMeetModal from './components/Modals/createMeetModal';

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route {...rest} render={props => authenticated === true ? (
      <Component {...props}/>
    ) : (<Redirect to={{ pathname: "/", state: { from: props.location } }} />

    )
    } />
  );
}

function PublicRoute({ component: Component, authenticated, ...rest }) {

  const fromm = localStorage.getItem('from');

  console.log(fromm);
  return (
    <Route
      {...rest}
      render={(props) => authenticated === false
        ? <Component {...props} />
        : <Redirect to={fromm !== null ? fromm : '/'} />}
    />
  )
}


class App extends Component {
  constructor() {
    super();
    this.state = {
      authenticated: false,
      loading: true,

    };


  }


  componentDidMount() {

    auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          authenticated: true,
          loading: false
        });
      } else {
        this.setState({
          authenticated: false,
          loading: false
        });
      }
    });
  }
  render() {
    return (
      <div className='app-wrapper'>
        {
          this.state.loading === true ?
            <Loader />
            : (
              <Router>
                <Switch>
                  <Route exact path="/" component={Home}></Route>
                  <PrivateRoute exact path="/room/:roomID" authenticated={this.state.authenticated} component={Room}></PrivateRoute>
                  <PrivateRoute exact path="/UserProfile" authenticated={this.state.authenticated} component={UserProfile}></PrivateRoute>
                  <PrivateRoute exact path="/CallEnded" authenticated={this.state.authenticated} component={CallEnded}></PrivateRoute>
                  <PrivateRoute exact path="/WaitingRoom" authenticated={this.state.authenticated} component={Waiting}></PrivateRoute>
                  <PrivateRoute exact path="/MyEvents" authenticated={this.state.authenticated} component={MyEvents}></PrivateRoute>
                  <Route path="/404" component={NoPage} />
                  <PrivateRoute authenticated={this.state.authenticated} component={Roomi}/> 
                 
                  <Redirect to="/404" />
                </Switch>
              </Router>
            )
        }
      </div>
    )

  }
}

export default App;